import React from 'react';
import PropTypes from 'prop-types';
import { Alert, Icon } from '@storable/canaveral-components';
import styles from './styles.scss';

const propTypes = {
  context: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
};

const defaultProps = {};

const AlertBanner = ({
  context,
  text,
  icon,
}) => (
  <Alert
    className={styles.alertBanner}
    context={context}
  >
    <Icon className={styles.icon} id={icon} context={context} label={icon} />
    <span className={styles.alertText}>{text}</span>
  </Alert>
);

AlertBanner.propTypes = propTypes;
AlertBanner.defaultProps = defaultProps;

export default AlertBanner;
